import React from "react";
import keyimg from '../../assets/images/keyimg.png'; 


function Hqtitle() {
  return ( 

    <div className="hqtitle">
      <img src={keyimg} alt="key" />
      <h2>HQ Account LOGGED</h2>
      <p>Please select CENTRE</p>
    </div>

    );
}

export default Hqtitle;
